export default {"src":"/_next/static/media/expertise-circular.4c8e2b9b.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};